import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { t } from "@lingui/macro";

const EditAddressForm = ({ address, onSave, onCancel }) => {
  const validationSchema = Yup.object({
    address1: Yup.string()
      .min(5, t`Must be at least 5 characters`)
      .required(t`Required`),
    address2: Yup.string(),
    city: Yup.string()
      .min(5, t`Must be at least 5 characters`)
      .required(t`Required`),
    state: Yup.string()
      .min(5, t`Must be at least 5 characters`)
      .required(t`Required`),
    zipCode: Yup.string()
      .matches(/^[0-9]{5}$/, t`Must be 5 digits`)
      .required(t`Required`),
    country: Yup.string()
      .min(2, t`Must be at least 2 characters`)
      .required(t`Required`),
  });

  return (
    <div className="form-container">
      <h2>{t`Edit Address`}</h2>

      <Formik
        initialValues={{
          address1: address?.address1 || "",
          address2: address?.address2 || "",
          city: address?.city || "",
          state: address?.state || "",
          zipCode: address?.zipCode || "",
          country: address?.country || "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSave(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-row">
              <label>{t`Street Address`}</label>
              <Field
                name="address1"
                type="text"
                className={`form-control ${
                  errors.address1 && touched.address1 ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                name="address1"
                component="div"
                className="form-control-feedback"
              />
            </div>

            <div className="form-row">
              <label>{t`Address 2`}</label>
              <Field name="address2" type="text" className="form-control" />
            </div>

            <div className="form-row">
              <label>{t`City`}</label>
              <Field
                name="city"
                type="text"
                className={`form-control ${
                  errors.city && touched.city ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                name="city"
                component="div"
                className="form-control-feedback"
              />
            </div>

            <div className="form-row">
              <label>{t`State`}</label>
              <Field
                name="state"
                type="text"
                className={`form-control ${
                  errors.state && touched.state ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                name="state"
                component="div"
                className="form-control-feedback"
              />
            </div>

            <div className="form-row">
              <label>{t`Zip Code`}</label>
              <Field
                name="zipCode"
                type="text"
                className={`form-control ${
                  errors.zipCode && touched.zipCode ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                name="zipCode"
                component="div"
                className="form-control-feedback"
              />
            </div>

            <div className="form-row">
              <label>{t`Country`}</label>
              <Field
                name="country"
                type="text"
                className={`form-control ${
                  errors.country && touched.country ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                name="country"
                component="div"
                className="form-control-feedback"
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="submit-btn">
                {t`Save`}
              </button>
              <button
                type="button"
                onClick={onCancel}
                className="cancel-btn"
              >
                {t`Cancel`}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditAddressForm;
